import { perspectiveIdFromPath } from "@/lib/perspectives";

/** Kanta / one salkku / one building — the three ADR-014 scopes the chrome switch picks. */
export type ScopeKind = "all" | "group" | "building";

export function scopeKindFromIds(
  buildingId: string | null,
  groupId: string | null,
): ScopeKind {
  if (buildingId !== null) return "building";
  if (groupId !== null) return "group";
  return "all";
}

/** Whether Rajaa renders above the topbar scope switch. Hidden only after a building is
 *  picked — city/type/status still narrow the Kiinteistöt pick list before that.
 *  Status facet is Etusivu / Toiminnot only. */
export type ChromeInventoryFilterMode =
  "hidden" | "with-status" | "without-status";

export function chromeInventoryFilterMode(
  buildingId: string | null,
  pathname: string,
): ChromeInventoryFilterMode {
  if (buildingId !== null) return "hidden";
  if (perspectiveIdFromPath(pathname) !== null) return "without-status";
  return "with-status";
}
